export const buildConstraintPath = (constraintName: string, constraintId: string): string =>
  `/constraints/${constraintName.replaceAll(' ', '_').replaceAll('-', '_').toUpperCase()}-${constraintId}`;
